import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'LD',
  quote: 'Hice mis primeros trabajos y ya tengo tres clientes del barrio',
  name: 'Lucas D.',
  location: 'Lanús'
}, {
  initials: 'DS',
  quote: 'Es como tener un técnico al lado explicándote todo',
  name: 'Diego S.',
  location: 'Mar del Plata'
}];
export function ShortTestimonials() {
  return <section className="py-10 px-4 bg-brand-navy" data-id="element-249">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-250">
        {testimonials.map((t, i) => <div key={i} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl shadow-lg border border-white/10 flex flex-col items-center text-center" data-id="element-251">
            <div className="w-16 h-16 bg-brand-primary text-white rounded-full flex items-center justify-center text-xl font-bold mb-4" data-id="element-252">
              {t.initials}
            </div>
            <div className="flex text-brand-amber mb-4" data-id="element-253">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-254" />)}
            </div>
            <p className="text-xl font-bold text-white mb-4 italic" data-id="element-255">
              "{t.quote}"
            </p>
            <p className="text-base text-blue-200 font-medium" data-id="element-256">
              — {t.name}, {t.location}
            </p>
          </div>)}
      </div>
    </section>;
}